import {
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import {
  AuthService,
  ConfigStateService,
  SessionStateService,
  RoutesService,
} from '@abp/ng.core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'abp-layout-coaching',
  templateUrl: './coaching-layout.component.html',
  styleUrls: ['./coaching-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CoachingLayoutComponent implements OnInit {
  private readonly sessionState = inject(SessionStateService);
  private readonly authService = inject(AuthService);
  private readonly routesService = inject(RoutesService);
  private readonly configState = inject(ConfigStateService);
  private readonly router = inject(Router);

  isSidebarCollapsed = false;
  isMobileMenuOpen = false;
  currentUserRole: string = '';

  get currentUser$(): Observable<any> {
    return this.configState.getOne$('currentUser');
  }

  get visibleRoutes$() {
    return this.routesService.visible$.pipe(
      map(routes => {
        // Flatten the tree structure
        const flattenRoutes = (nodes: any[]): any[] => {
          return nodes.reduce((acc, node) => {
            if (node.path) {
              acc.push(node);
            }
            if (node.children && node.children.length > 0) {
              acc.push(...flattenRoutes(node.children));
            }
            return acc;
          }, []);
        };
        return flattenRoutes(routes);
      })
    );
  }

  get appInfo() {
    const config = this.configState.getAll();
    const defaultResourceName = config?.localization?.defaultResourceName;
    return {
      name: defaultResourceName || 'MyApp',
      logoUrl: null as string | null
    };
  }

  ngOnInit() {
    // Get current user role
    this.currentUser$.subscribe(user => {
      if (user && user.roles) {
        this.currentUserRole = user.roles[0]; // İlk rolü al
      }
    });
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  onLogout() {
    this.authService.logout().subscribe();
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }

  // This method is deprecated - use visibleRoutes$ instead which respects permissions
  getMenuItems(): any[] {
    console.warn('getMenuItems() is deprecated. Use visibleRoutes$ from RoutesService which respects permissions.');
    return [];
  }
}